var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`text-${_vm.sectionData.align} q-my-sm q-mx-sm`},[_c('q-btn',{class:_vm.sectionData.class,attrs:{"unelevated":"","no-caps":"","size":"md","label":_vm.sectionData.label,"icon":_vm.sectionData.icon},on:{"click":_vm.invokeComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }